import { useState, useEffect } from "react";

import {
  Row,
  Col,
  Breadcrumb,
  Button,
  Drawer,
  Typography,
  Form,
  Input,
  Modal,
  notification,
} from "antd";

import { NavLink } from "react-router-dom";
import styled from "styled-components";
import useAppStore from "../../store";
import axios from "axios";
import { apiRoutes } from "../../constants/apiRoutes";

const ButtonContainer = styled.div`
  .ant-btn-primary {
    background-color: #1890ff;
  }
  .ant-btn-success {
    background-color: #52c41a;
  }
  .ant-btn-yellow {
    background-color: #fadb14;
  }
  .ant-btn-black {
    background-color: #262626;
    color: #fff;
    border: 0px;
    border-radius: 5px;
  }
  .ant-switch-active {
    background-color: #1890ff;
  }
`;

const logsetting = [
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    key={0}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
      fill="#111827"
    ></path>
  </svg>,
];
const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({
  placement,
  name,
  subName,
  onPress,
}) {
  const user = useAppStore((state) => state.user);
  const { Title, Text } = Typography;
  const setToken = useAppStore((state) => state.setToken);
  const [visible, setVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setLoading] = useState(false);
  const showDrawer = () => setVisible(true);
  const hideDrawer = () => setVisible(false);

  const openNotificationWithIcon = (config) => {
    api[config.type]({
      key: config.key,
      message: config.message,
      description: config.description,
      duration: 5,
    });
  };

  const onCloseModal = () => {
    setIsModalOpen(false);
  }

  const onFinish = (formData) => {
    setLoading(true);
    const values = {
      ...formData,
    }

    if (values.confirm_password) delete values.confirm_password;
    Object.keys(values).forEach(key => values[key] === undefined && delete values[key]);

    console.log("Form is valid:", values);

    axios.patch(`${process.env.REACT_APP_AUTH_API_URL}${apiRoutes.user}?user_id=${user.user_id}`, values)
      .then((res) => {
        setLoading(false);
        openNotificationWithIcon({
          key: 'updated',
          type: 'success',
          message: "Update successful",
          description: `Profile was updated`
        });
        setToken(res.data.data.token);
        setIsModalOpen(false);
      })
      .catch((e) => {
        setLoading(false);
        console.log(e.response.data.error);
        openNotificationWithIcon({
          type: 'error',
          message: "Error saving profile",
          description: e?.response?.data?.error || e.message
        })
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => window.scrollTo(0, 0));

  return (
    <>
      {/* <div className="setting-drwer" onClick={showDrawer}>
        {setting}
      </div> */}
      {contextHolder}
      {isModalOpen && <EditUserModal
        isLoading={isLoading}
        isModalOpen={isModalOpen}
        onCloseModal={onCloseModal}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        user={user}
      />}
      <Row gutter={[24, 0]}>
        <Col span={24} md={6}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <NavLink to="/">Home</NavLink>
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ textTransform: "capitalize" }}>
              {name.replace("/", " / ")}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="ant-page-header-heading">
            <span
              className="ant-page-header-heading-title"
              style={{ textTransform: "uppercase" }}
            >
              {subName.slice(subName.indexOf("/") + 1)}
            </span>
          </div>
        </Col>
        <Col span={24} md={18} className="header-control">
          {/* <Badge size="small" count={4}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <a
                href="#pablo"
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                {bell}
              </a>
            </Dropdown>
          </Badge> */}
          <Button type="link" onClick={showDrawer}>
            {logsetting}
          </Button>
          <Button
            type="link"
            className="sidebar-toggler"
            onClick={() => onPress()}
          >
            {toggler}
          </Button>
          <Drawer
            className="settings-drawer"
            mask={true}
            width={360}
            onClose={hideDrawer}
            placement={placement}
            visible={visible}
          >
            <div layout="vertical">
              <div className="header-top">
                <Title level={4}>
                  {user ? `${user.first_name} ${user.last_name}` : "User"}
                  <Text className="subtitle">{user ? `${user.email}` : "<unkown_user>"}</Text>
                </Title>
              </div>

              <div className="sidebar-color">
                <div className="ant-docment">
                  <ButtonContainer>
                    <Button type="black" size="large" onClick={() => setIsModalOpen(true)}>Edit Profile</Button>
                    <Button size="large" onClick={() => { setToken("") }}>Sign Out</Button>
                  </ButtonContainer>
                </div>
              </div>
            </div>
          </Drawer>
          {/* <Link to="/sign-in" className="btn-sign-in">
            {profile}
            <span>Sign in</span>
          </Link> */}
          {/* <Input
            className="header-search"
            placeholder="Type here..."
            prefix={<SearchOutlined />}
          /> */}
        </Col>
      </Row>
    </>
  );
}

// extracted out since it was updating the Cascade options dynamically.
const EditUserModal = ({
  user_id,
  isLoading,
  isModalOpen,
  onCloseModal,
  onFinish,
  onFinishFailed,
  user,
}) => {
  const [form] = Form.useForm();
  const onOk = () => {
    form.submit();
  };

  return (
    <Modal
      className="the_modal_man_this_is_the_modal"
      title="Edit User Information"
      centered
      open={isModalOpen}
      onOk={onOk}
      onCancel={onCloseModal}
    >
      <Form
        name="basic"
        initialValues={{ remember: true }}
        onFinish={(formData) => onFinish(formData, user_id)}
        onFinishFailed={onFinishFailed}
        className="row-col"
        layout="vertical"
        form={form}
      >
        <Form.Item
          name="first_name"
          label="First Name"
          rules={[
            // { required: true, message: "Please input your First Name" },
          ]}
        >
          <Input placeholder="First Name" defaultValue={user.first_name} />
        </Form.Item>
        <Form.Item
          name="last_name"
          label="Last Name"
          rules={[
            // { required: true, message: "Please input your Last Name" },
          ]}
        >
          <Input placeholder="Last Name" defaultValue={user.last_name} />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            // { required: true, message: "Please input your email!" },
          ]}
        >
          <Input placeholder="Email" defaultValue={user.email} />
        </Form.Item>
        <Form.Item
          name="password"
          label="New Password"
          rules={[
            // { required: true, message: "Please input your password!" },
          ]}
        >
          <Input.Password placeholder="New Password" />
        </Form.Item>
        <Form.Item
          name="confirm_password"
          label="Confirm Password"
          dependencies={['password']}
          rules={[
            // {
            //   required: true,
            //   message: 'Please confirm your password!',
            // },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('The new password that you entered do not match!'));
              },
            }),
          ]}
        >
          <Input.Password placeholder="Confirm Password" />
        </Form.Item>

        <Form.Item>
          <Button
            style={{ width: "100%" }}
            type="primary"
            htmlType="submit"
            loading={isLoading}
          >
            Save Changes
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default Header;
